// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"gqfNQKzb2NgH4gOb5nJy","title":"y67K1CoDUp6k98IC8eLh","subtitle":"BOhI1voIaQ28QnJI3H2S"};